module.exports = __webpack_public_path__ + "img/tutor-icon.83edc93c.svg";